import {
  Injectable
} from '@angular/core';
import { IAirApplicationAutomatorRequest, IAirSaveOfferRequest } from 'libraries/service/resources/model/booking/air/IAirSaveOffer';
import { IOnOfferSelectedNotificationSetup } from 'libraries/service/resources/model/booking/air/IAirCreateBooking';
import { AirOfferResourceService } from 'libraries/service/resources/airOffer/airOfferResource.service';
import { Observable } from 'rxjs';
import { ResponseForConvertOfferAfx2jsonType } from '@afidium/ts-facade';
import { PostExtraService } from './post-extra.service';
import {
  IAirGetQuotedAvailabilityRequest
} from "../../libraries/service/resources/model/booking/air/IAirQuotedAvailability";
import {
  IAirQuotedAvailabilityResponse
} from "../../libraries/service/resources/model/booking/air/IAirQuotedAvailabilityResponse";
import {AirQuoteMappingService} from "../../libraries/service/resources/airQuote/air-quote-mapping.service";

@Injectable()
export class OfferService {

  constructor(
    private readonly airOfferResourceService: AirOfferResourceService,
    private readonly postExtraService: PostExtraService,
    private readonly airQuoteMappingService: AirQuoteMappingService
  ) {}

  public buildGetRequest(gqaData: any): { quote : IAirQuotedAvailabilityResponse, booking: any } {
    const quote : IAirQuotedAvailabilityResponse = this.airQuoteMappingService
        .mapGqaNewToOld(gqaData) as unknown as IAirQuotedAvailabilityResponse;
    const booking : any = {
      ...gqaData,
      key: `air_${gqaData.transaction.key}`,
      booking: {
        [gqaData.offer.priceArray[0].cost.xId]: quote
      }
    };

    return { quote, booking };
  }

  public buildPostRequest(key: string, content: ResponseForConvertOfferAfx2jsonType, onOfferSelectedNotificationArray? : IOnOfferSelectedNotificationSetup[]): IAirSaveOfferRequest {
    return {
      key,
      content,
      onOfferSelectedNotificationArray,
      postExtra: this.postExtraService.getPostExtra()
    };
  }

  public buildKey(idSearch: string, idQuote: string, idAlt?: string): string {
    const result = `SQA$${idSearch}$QUOT$${idQuote}`;
    return idAlt ? `${result}$ALT$${idAlt}` : result;
  }

  public buildRequestSaveBest(content: any): IAirApplicationAutomatorRequest{
    return {
      content
    }
  }

  public saveOffer(request: IAirSaveOfferRequest, target: string): Observable<any> {
    return this.airOfferResourceService.postOffer(request, target);
  }

  public saveBestOffer(request: IAirApplicationAutomatorRequest, target: string): Observable<any> {
    return this.airOfferResourceService.postBestOffer(request, target);
  }

  public getSavedOffer(request: IAirApplicationAutomatorRequest, target: string): Observable<IAirGetQuotedAvailabilityRequest>{
    return this.airOfferResourceService.getOffer(request, target);
  }
}